module.exports = __webpack_public_path__ + "static/media/customer-image-placeholder.cac3463f.svg";